var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-quiz-body"},[_c('h2',{staticClass:"question"},[_vm._v(_vm._s(_vm.question.content))]),_vm._v(" "),_c('answers',{attrs:{"answers":_vm.question.options,"multiselect":_vm.question.multiselect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }